import {Tooltip, TooltipProps} from 'platform/components';

import {ReactElement} from 'react';

export const HeaderCellTooltip = (props: TooltipProps): ReactElement => (
  <Tooltip placement="top" {...props} />
);
